/**
 * hq-cart-bundles
 *
 * Remove on a bundle set line takes the WHOLE set out of the cart, and a
 * shopper who tries to change a set line's quantity is told why they can't.
 *
 * A set is priced as one thing at checkout (the bundle-tier-discount Function
 * groups lines by their hidden _bundle_id), so a set with one length missing
 * would drop to a smaller tier while still reading "3-bundle set" in the cart.
 * Quantities on set lines are locked in Liquid (data-hq-set-locked): the
 * +/- buttons are aria-disabled rather than disabled, so a press reaches the
 * capture listener below, which stops it before Dawn's QuantityInput sees it
 * and writes a short note into the line's own error slot (the one Dawn uses
 * for "only 2 left"). The note appears only when someone actually tries.
 *
 * The Liquid puts every key of the set on the button (data-bundle-keys, from
 * snippets/hq-bundle-line-keys). One /cart/update.js call zeroes them all and
 * re-renders the same sections Dawn's own remove does, through the cart
 * element's own getSectionsToRender/getSectionInnerHTML, so the page ends up
 * exactly as after a normal remove. cart.js itself is not modified.
 *
 * Without JS the remove link still removes the one line, and the Function
 * re-prices what is left of the set at its new size.
 */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else {
    root.HqCartBundles = api;
    api.install(root.document);
  }
}(typeof self !== 'undefined' ? self : this, function () {
  'use strict';

  var SET_LOCKED_NOTE = 'This is part of a bundle set. To change it, remove the set and build a new one.';

  /** Shows the note in the error slot of the cart line that holds `el`. */
  function showSetNote(el) {
    var line = el.closest && el.closest('.cart-item');
    var text = line && line.querySelector('.cart-item__error-text');
    if (!text) return false;
    text.textContent = SET_LOCKED_NOTE;
    return true;
  }

  /** "k1,k2" -> { k1: 0, k2: 0 }; blanks and duplicates dropped. */
  function updatesForKeys(keys) {
    var updates = {};
    String(keys || '').split(',').forEach(function (key) {
      var k = key.trim();
      if (k) updates[k] = 0;
    });
    return updates;
  }

  function render(host, sections, state) {
    var empty = state.item_count === 0;
    host.classList.toggle('is-empty', empty);
    var footer = document.getElementById('main-cart-footer');
    if (footer) footer.classList.toggle('is-empty', empty);
    var drawer = document.querySelector('cart-drawer');
    if (drawer) drawer.classList.toggle('is-empty', empty);

    sections.forEach(function (section) {
      var el = document.getElementById(section.id);
      var html = state.sections && state.sections[section.section];
      if (!el || html == null) return;
      var target = el.querySelector(section.selector) || el;
      target.innerHTML = host.getSectionInnerHTML(html, section.selector);
    });
  }

  function removeSet(button) {
    var host = button.closest('cart-items, cart-drawer-items');
    var updates = updatesForKeys(button.dataset.bundleKeys);
    if (!host || typeof host.getSectionsToRender !== 'function' || !Object.keys(updates).length) return false;

    var line = button.dataset.index;
    var sections = host.getSectionsToRender();
    if (typeof host.enableLoading === 'function') host.enableLoading(line);

    var url = (window.routes && window.routes.cart_update_url) || '/cart/update';
    fetch(url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        updates: updates,
        sections: sections.map(function (s) { return s.section; }),
        sections_url: window.location.pathname,
      }),
    })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        if (!state || state.status || state.errors) throw new Error((state && (state.description || state.errors)) || 'Cart update failed');
        render(host, sections, state);
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'hq-cart-bundles', cartData: state });
        }
      })
      .catch(function (err) {
        console.error('[hq-cart-bundles]', err);
        /* Whatever happened server-side, show the real cart. */
        window.location.reload();
      })
      .finally(function () {
        if (typeof host.disableLoading === 'function') host.disableLoading(line);
      });
    return true;
  }

  /**
   * Capture phase on the document runs before CartRemoveButton's own click
   * listener, so a set button is handled here and never reaches it. A set of
   * one line is left to Dawn — it is the same request.
   */
  function install(doc) {
    if (!doc || doc.__hqCartBundles) return;
    doc.__hqCartBundles = true;
    doc.addEventListener('click', function (event) {
      var button = event.target.closest && event.target.closest('cart-remove-button[data-bundle-keys]');
      if (!button) return;
      if (Object.keys(updatesForKeys(button.dataset.bundleKeys)).length < 2) return;
      event.preventDefault();
      event.stopPropagation();
      removeSet(button);
    }, true);

    /* + / - on a set line: never reaches QuantityInput; the quantity stays as it is. */
    doc.addEventListener('click', function (event) {
      var locked = event.target.closest && event.target.closest('[data-hq-set-locked]');
      if (!locked) return;
      if (locked.tagName !== 'INPUT') {
        event.preventDefault();
        event.stopPropagation();
      }
      showSetNote(locked);
    }, true);

    /* Typing in a set line's (read-only) quantity box: explain instead. */
    doc.addEventListener('keydown', function (event) {
      var input = event.target;
      if (!input || !input.matches || !input.matches('input[data-hq-set-locked]')) return;
      if (event.metaKey || event.ctrlKey || event.altKey) return;
      if (/^(Tab|Shift|Escape|ArrowLeft|ArrowRight|Home|End|Enter)$/.test(event.key)) return;
      event.preventDefault();
      showSetNote(input);
    }, true);
  }

  return { updatesForKeys: updatesForKeys, install: install, removeSet: removeSet, showSetNote: showSetNote, SET_LOCKED_NOTE: SET_LOCKED_NOTE };
}));
